import clsx from "clsx";

import { Badge } from "V2.0/common/badge";

import { modelIcons } from "../../../ModelSettings/GPTResponseModelCategorized/gptModels";
import { getModelName } from "../../../ModelSettings/GPTResponseModelCategorized/GPTResponsePremiumModel";

export default EvalRunResultItem;

function EvalRunResultItem(props) {
  const { evalRunResultItem, onResultItemClick, isActiveResultItem } = props;

  // Not every model in the backend enum has an icon here, and rendering an
  // undefined component throws. Fall back to no icon rather than a blank screen.
  const Icon = modelIcons[evalRunResultItem.model];

  const score = averageScore(evalRunResultItem.scores);

  return (
    <div
      className={clsx(
        "flex shrink-0 items-center justify-between p-4 overflow-hidden transition duration-150 ease-in-out cursor-pointer gap-x-2",
        isActiveResultItem && "bg-gray-100",
        !isActiveResultItem && "hover:bg-gray-100",
      )}
      onClick={onResultItemClick}
    >
      <div className="flex items-center gap-x-2 min-w-0">
        {Icon && (
          <div className="min-h-8 min-w-8 bg-white rounded-lg border flex justify-center items-center">
            <Icon />
          </div>
        )}

        {/* items-start so each badge is only as wide as its own text — in a
            plain flex column they stretch to the container, which made "Sad"
            as wide as "Gemini 3.1 Flash Lite". */}
        <div className="flex flex-col items-start gap-y-1.5 min-w-0">
          <Badge>{getModelName(evalRunResultItem.model)}</Badge>
          <Badge>{evalRunResultItem.persona}</Badge>
        </div>
      </div>

      {/* The score belongs on the row: without it you have to open every
          combination to find the one that did badly. */}
      <div className="shrink-0 text-right">
        <span className="text-lg font-semibold tabular-nums text-gray-900">
          {score === null ? "—" : score.toFixed(1)}
        </span>
        <span className="ml-0.5 text-xs text-gray-400">/10</span>
      </div>
    </div>
  );
}

function averageScore(scores): number | null {
  const values = (scores ?? [])
    .map((score) => score?.score)
    .filter((score) => typeof score === "number");

  if (values.length === 0) return null;

  return values.reduce((sum, value) => sum + value, 0) / values.length;
}
